import { Dispatch } from "redux";
import { searchNewKeyWork, showHideLoading, Types } from "./actions";
import { getSearchResultsService } from "./services";
import { IRefinement, IRefinements } from "./types";

export const getSearchResultsDispatch = (
    options: IRefinements,
    hasRnDUserRole: boolean | undefined,
    callback: any // callback
) => async (dispatch: Dispatch) => {
    dispatch(showHideLoading(Types.SHOW_LOADING));
    try {
        const searchResultsObj = await getSearchResultsService(options, hasRnDUserRole)
        dispatch(searchNewKeyWork(searchResultsObj));
        dispatch(showHideLoading(Types.HIDE_LOADING));
    }
    catch {
        dispatch(showHideLoading(Types.SHOW_ERROR));
    }
};

export function updateURLWithRefinements(
    refinements: IRefinement[],
    location: any,
    history: any,
    dispatchAddRefinements: (refinements: IRefinement[]) => void
) {
    const searchParams = new URLSearchParams(location.search);

    refinements.forEach(ref => {
        searchParams.set(ref.name, ref.value);
        !ref.value && searchParams.delete(ref.name);
    });

    history.push({
        search: searchParams.toString()
    });

    dispatchAddRefinements(refinements);
}